import { DisplayTypes } from '../constants';

const formatter = 'single';

/**
 * Format result that that is returned from a singular query (not timeseries, or grouped)
 */
export default function formatSingleResult(kpi, result) {
  const displayType = kpi.getDisplayType();
  let displayData = {
    value: null,
  };

  const { data, meta: { typeY0 } } = result;
  const { property } = kpi.measurements[0];
  const { displayOptions: { displayBoundaries, units } } = kpi;

  const displayColours = (typeY0 === 'percentage' && displayBoundaries === undefined)
      || displayBoundaries === true;

  [displayData] = data.map(({
    y0, displayY0, level0, devices,
  }) => ({
    rawValue: y0,
    value: displayY0,
    state: displayColours
      ? level0
      : undefined,
    subtitle: devices ? `${devices} total devices` : undefined,
    units: units || null,
  }));

  if (displayType === DisplayTypes.GAUGE) {
    if (kpi.isPercent()) {
      displayData.maxValue = 100;
      displayData.isPercent = true;
    } else {
      const { min, max } = kpi.getValueBounds();
      displayData.minValue = min;
      displayData.maxValue = max;
      if (property && property.factor) {
        displayData.factor = property.factor;
      }
    }
  }

  return {
    displayType,
    displayData,
    isPercent: kpi.isPercent(),
    formatter,
  };
}
